import {
    MAX_RENDER_ZOOM,
    MIN_RENDER_ZOOM,
    OVERVIEW_MAX_WIDTH,
    OVERVIEW_MIN_WIDTH,
    OVERVIEW_WIDTH_STEP,
    RENDER_ZOOM_MAX_OVERSAMPLE,
    RENDER_ZOOM_MIN_SHARPNESS,
    RENDER_ZOOM_STEPS_PER_OCTAVE,
    TILE_EPSILON_STEP,
} from '../constants';

const OCTAVE_BASE = 2;

export const quantizeRenderZoom = (displayZoom: number, dpr: number): number => {
    const device = Math.max(displayZoom * dpr, MIN_RENDER_ZOOM);
    const steps = Math.ceil(Math.log2(device) * RENDER_ZOOM_STEPS_PER_OCTAVE - TILE_EPSILON_STEP);
    return Math.min(MAX_RENDER_ZOOM, OCTAVE_BASE ** (steps / RENDER_ZOOM_STEPS_PER_OCTAVE));
};

export const isRenderZoomUsable = (layerZoom: number, displayZoom: number, dpr: number): boolean => {
    const device = Math.max(displayZoom * dpr, MIN_RENDER_ZOOM);
    return layerZoom >= Math.min(device, MAX_RENDER_ZOOM) * RENDER_ZOOM_MIN_SHARPNESS
        && layerZoom <= device * RENDER_ZOOM_MAX_OVERSAMPLE;
};

export const quantizeOverviewWidth = (cssWidth: number): number => Math.min(
    OVERVIEW_MAX_WIDTH,
    Math.max(OVERVIEW_MIN_WIDTH, Math.ceil(cssWidth / OVERVIEW_WIDTH_STEP) * OVERVIEW_WIDTH_STEP),
);
